export enum CATEGORY_ID {
  ROOT = '1',
}
